document.addEventListener("DOMContentLoaded", function () {

    window.addEventListener("load", function () {

        function showButton() {
            const btn = document.querySelector(".custom-whatsapp");

            if (btn) {
                btn.style.display = "flex";
            }
        }

        if ("requestIdleCallback" in window) {
            requestIdleCallback(showButton);
        } else {
            setTimeout(showButton, 1000);
        }

    });

});